module.exports = __webpack_public_path__ + "img/collection-engagementRings@2x.d6720e8.jpg";